import { useIntl } from "react-intl";

import Box from "@mui/material/Box";
import { Link } from "@mui/material";
import CustomIcon from "../CustomIcon";
import icons from "../../enums/icons";

import { flattenSectorProductsDomain } from "services/company/company.functions";

// Styles
import companySummaryStyles from "./CompanySummary.styles";

const CompanySummaryBody = ({
    companyData,
}: {
    companyData: ReturnType<typeof flattenSectorProductsDomain> | undefined;
}) => {
    const classes = companySummaryStyles();
    const intl = useIntl();

    const employeeCount = companyData?.employee_count ?? "?";
    const mainOffice = companyData?.locations?.at(0)?.country?.name ?? "?";
    const domain = companyData?.domains?.at(0)?.domain;

    return (
        <Box className={classes.summaryItemContainer}>
            <Box sx={{ display: "flex", alignItems: "baseline" }}>
                <Box className={classes.summaryItem}>
                    <Box display="flex" alignItems="center" mb={0.6}>
                        <CustomIcon icon={icons.office} className={classes.summaryItemIcon} />
                        <Box component="span" className={classes.summaryItemLabel}>
                            {intl.formatMessage({ id: "companySummary.mainOffice" })}
                        </Box>
                    </Box>
                    <Box className={classes.summaryItemValue}>{mainOffice}</Box>
                </Box>
                <Box className={classes.summaryItem}>
                    <Box display="flex" alignItems="center" mb={0.6}>
                        <CustomIcon icon={icons.graph} className={classes.summaryItemIcon} />
                        <Box component="span" className={classes.summaryItemLabel}>
                            {intl.formatMessage({ id: "companySummary.employees" })}
                        </Box>
                    </Box>
                    <Box className={classes.summaryItemValue}>{employeeCount}</Box>
                </Box>

                {domain && (
                    <Box className={classes.summaryItem} display="flex" alignItems="center">
                        <CustomIcon icon={icons.hyperlink} className={classes.summaryIconLink} />
                        <Link
                            className={classes.summaryItemLink}
                            href={`https://${domain}`}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            {intl.formatMessage({ id: "companySummary.website" })}
                        </Link>
                    </Box>
                )}
            </Box>
        </Box>
    );
};

export default CompanySummaryBody;
